import debouncePromise from "awesome-debounce-promise";
import validatePassword from "../../validatePassword";

export default {
    required: true,
    minLength: 8,
    maxLength: 100,
    validate: {
        asyncValidation: debouncePromise( async (value) => await validatePassword(value).then((response)=>{
            return true;
        }).catch((error)=>{
            return !!error && Array.isArray(error) && error.length ? error.join(', ') : false;
        }), 800),
}};
